import type { FetchResponse } from '@sydle/ui-api';
import { portalCustomAPI } from '.';
import type { TicketComment } from '../models/ticket/TicketComment';

export interface GetTicketCommentsInput {
  ticketId: string;
  searchCode?: string;
  ratingCode?: string;
  returnFields?: string[];
}

export interface GetTicketCommentsOutput {
  comments?: TicketComment[];
  pendencies?: TicketComment[];
}

export async function getTicketComments(
  input: GetTicketCommentsInput,
): Promise<FetchResponse<GetTicketCommentsOutput>> {
  return await portalCustomAPI.fetch<GetTicketCommentsInput, GetTicketCommentsOutput>('getTicketComments', input);
}
